import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../../services/api/API";
import "./agentDetails.scss";

const AgentDetails = () => {
  const location = useLocation();
  const { data } = location.state || {};
  const authToken = localStorage.getItem("authToken");

  const navigate = useNavigate()

  const [fetchOnboardDetails, setfetchOnboardDetails] = useState([]);
  const [fetchConfigData, setFetchConfigData] = useState([]);
  const [images, setImages] = useState([]);
  const [configformData, setConfigformdata] = useState({});
  const [formData, setFormData] = useState({});
  const [fetchUploadDocumentData, setfetchUploadDocumentData] = useState([]);

  const [onboardProcessType, setOnboardProcessType] = useState("");

  const fetchConfig = async () => {
    try {
      const response = await axiosInstance.get(
        `/bp-onboard/getConfig/${data.onboard_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const fetchedConfigData = response.data.data.data;

      // Assuming the response data is an array and you want the first element
      if (Array.isArray(fetchedConfigData) && fetchedConfigData.length > 0) {
        setFetchConfigData(fetchedConfigData[0]);
      } else {
        console.error("Fetched config data is not in the expected format.");
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchedOnBoardDetails = async () => {
    try {
      const response = await axiosInstance.get(
        `/bp-onboard/edit/${data.onboard_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const fetchedData = response.data.data;
      console.log(fetchedData, "fetchedData");
      const transformedData = {
        onboard_process_type: fetchedData.onboard_process_type,
        bp_type: fetchedData.bp_type,
        bp_name: fetchedData.bp_name,
        contact_no: fetchedData.contact_no,
        email_id: fetchedData.email_id,
        pincode: fetchedData.pincode,
        city_id: fetchedData.city_id,
        country_id: fetchedData.country_id,
        state_id: fetchedData.state_id,
        bp_address: fetchedData.bp_address,
        gst_no: fetchedData.gst_no,
        remark: fetchedData.remark,
        status: fetchedData.status,
      };
      setFormData(transformedData);
      console.log(fetchedData, "fetchConfigData");

      const onObType = fetchedData?.onboard_process_type;
      setOnboardProcessType(onObType);

      setfetchOnboardDetails(fetchedData);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    fetchedOnBoardDetails();
  }, []);

  const fetchDocuments = async () => {
    try {
      const response = await axiosInstance.get(
        `/bp-onboard/getDocument/${data.onboard_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const fetchedData = response.data.data.data;
      console.log(fetchedData, "FETCHED");
      const transformedData = {
        adhaarcard: null,
        pan: null,
        cancelcheque: null,
        agreementcopy: null,
        businesslicense: null,
        environmentalpolicy: null,
      };

      fetchedData.forEach((doc) => {
        switch (doc.document_type) {
          case 1:
            transformedData.adhaarcard = doc.image_path;
            break;
          case 2:
            transformedData.pan = doc.image_path;
            break;
          case 3:
            transformedData.cancelcheque = doc.image_path;
            break;
          case 4:
            transformedData.agreementcopy = doc.image_path;
            break;
          case 5:
            transformedData.businesslicense = doc.image_path;
          default:
            break;
        }
      });

      console.log(transformedData, "Transformed Data"); // Log the transformed data

      setImages(transformedData);

      setfetchUploadDocumentData(fetchedData);
      console.log(setfetchUploadDocumentData, "UPLOADDOCUMENT");
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, []);


  const backNavigation = () => {
    navigate("/admin/manage-onboard/onboard")
  }

  return (
    <div>
      <div className="details-container">
        <div onClick={backNavigation} className="backbutton mt-2 mb-2">
          <img src={backicon} alt="back" />
          {onboardProcessType === "customer" ? (
            <span className="backbtntitleDetails"> Business Partner Details</span>
          ) : (
            <span className="backbtntitleDetails"> Business Partner Details</span>
          )}
        </div>

        <div className="details-section">
          <h5 className="mt-2 mb-2 header-details">Personal Details</h5>
          <div className="detail-grid">
            <div className="details-item">
              <span className="details-label">Business Partner Type</span>
              <span className="details-value">
                {" "}
                {fetchOnboardDetails.onboard_process_type}{" "}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Business Partner Name</span>
              <span className="details-value">
                {fetchOnboardDetails.bp_name}{" "}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Contact Number</span>
              <span className="details-value">
                {fetchOnboardDetails.contact_no}{" "}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Email Address</span>
              <span className="details-value">
                {fetchOnboardDetails.email_id}{" "}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Pincode</span>
              <span className="details-value">
                {fetchOnboardDetails.pincode}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">City</span>
              <span className="details-value">
                {fetchOnboardDetails.city_name}{" "}
              </span>
            </div>

            <div className="details-item">
              <span className="details-label">State</span>
              <span className="details-value">
                {fetchOnboardDetails.state_name}{" "}
              </span>
            </div>

            <div className="details-item">
              <span className="details-label">Country</span>
              <span className="details-value">
                {fetchOnboardDetails.country_name}{" "}
              </span>
            </div>

            <div className="details-item">
              <span className="details-label">GST No.</span>
              <span className="details-value">
                {fetchOnboardDetails.gst_no}{" "}
              </span>
            </div>

            <div className="details-item">
              <span className="details-label">Address</span>
              <span className="details-value">
                {fetchOnboardDetails.bp_address}{" "}
              </span>
            </div>
          </div>

          <h5 className="header-details pt-4">Configuration</h5>
          <div className="detail-grid">
            <div className="details-item">
              <span className="details-label">Max Hierarchy Level</span>
              <span className="details-value">
                {fetchConfigData.max_hierarchy_level}{" "}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Total Users</span>
              <span className="details-value">
                {fetchConfigData.total_user}{" "}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">User Prefix</span>
              <span className="details-value">
                {fetchConfigData.user_prefix}{" "}
              </span>
            </div>
          </div>

          <h5 className="header-details">Documents</h5>
          <div className="detail-grid">
            <div className="details-item">
              <span className="details-label">Aadhar Card</span>
              {images.adhaarcard ? (
                <img
                  className="onboardDetailsImage"
                  src={images.adhaarcard}
                  alt="Adhaar Card"
                />
              ) : (
                <span>No Image</span>
              )}
            </div>
            <div className="details-item">
              <span className="details-label">Pancard</span>
              {images.pan && (
                <img
                  className="onboardDetailsImage"
                  src={images.pan}
                  alt="PAN Card"
                />
              )}
            </div>
            <div className="details-item">
              <span className="details-label">Cancel Cheque</span>
              {images.cancelcheque && (
                <img
                  className="onboardDetailsImage"
                  src={images.cancelcheque}
                  alt="Cancel Cheque"
                />
              )}
            </div>
            <div className="details-item">
              <span className="details-label">Agreement Copy</span>
              {images.agreementcopy && (
                <img
                  className="onboardDetailsImage"
                  src={images.agreementcopy}
                  alt="Agreement Copy"
                />
              )}
            </div>

            <div className="details-item">
              <span className="details-label">Business Licence</span>
              {images.businesslicense && (
                <img
                  className="onboardDetailsImage"
                  src={images.businesslicense}
                  alt="Agreement Copy"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentDetails;
